const ticketTypes = ['ticketOrPass', 'flexible', 'payAsYouGo'] as const;
export type TicketType = typeof ticketTypes[number] ;

export function parseTicketType(maybeTicketType: string): TicketType | undefined {
  return ticketTypes.find((validName) => validName === maybeTicketType);
}
